import { Component, OnInit, Input } from '@angular/core';
import { UserType, PermissionType } from '@enums';
import { SxPermissionService } from '@services';

@Component({
    selector: '[app-sec-trim]',
    template: '<ng-content *ngIf="shouldRender"></ng-content>',
    standalone: false
})
export class SecurityTrimComponent implements OnInit {
  @Input() userTypes: UserType[];
  @Input() permissions: PermissionType[];
  @Input() customerId: string;
  @Input() managerCompanyId: number;

  shouldRender: boolean;

  constructor(private sxPermissionService: SxPermissionService) {}

  ngOnInit() {
    this.shouldRender = this.sxPermissionService.securityTrim(
      this.userTypes,
      this.permissions,
      this.customerId,
      this.managerCompanyId
    );
  }
}
